import cx from "classnames";
import parse from "html-react-parser";

// Components
import Button from "../../../components/Button/ButtonContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";
import { useRef } from "react";

export const ConferenceHeader = (props) => {
    const { conference } = props;
    const {
        date_string,
        description,
        image,
        is_active,
        is_legacy,
        location,
        microsite_link,
        register_link,
        link_button_text,
        title,
    } = conference || {};

    const divAgenda = useRef<HTMLInputElement | null>(null);

    const scrolLWithUseRef = () => {
      divAgenda.current?.scrollIntoView({ block: "center", behavior: "smooth" });
    };

    const scrollFun = () => {
      document
        .querySelector(`#agenda`)
        ?.scrollIntoView({ block: "start", behavior: "smooth" });

    };

    function renderActive() {
        return (
            <Section
                classes={cx(styles.header, styles["header--active"])}
                style={{ backgroundImage: `url(${image.url})` }}
            >
                <h1 className={styles.title}>{title}</h1>
                <span className={styles.description}>
                    {date_string} &mdash; {location}
                </span>
                <span className={styles.btn_region}>
                { is_active && (
                    <a
                        href={register_link}
                        rel="noreferrer"
                        target="_blank"
                        className={cx(styles.button, {
                            [styles["button--hidden"]]: !register_link,
                        })}
                    >
                        <Button className={styles.button} text={link_button_text} />

                    </a>
                )}

                { !is_active && (
                    <a
                        href={register_link}
                        rel="noreferrer"
                        target="_blank"
                    >
                        <Button className={styles.button} text="see agenda" onClick={() => scrollFun()}/>

                    </a>
                )}


                </span>
            </Section>
        );
    }

    function renderPast() {
        return (
            <Section
              classes={cx(styles.header, styles["header--past"])}
            >
                <h1 className={styles.title}>{title}</h1>
                <span className={styles.description}>
                    {description && <span>{parse(conference.description)}</span>}
                </span>

                <a
                    href={register_link}
                    rel="noreferrer"
                    target="_blank"
                >
                    <Button className={styles.button} text="see agenda" onClick={() => scrollFun()}/>

                </a>

                {microsite_link && (
                    <a href={microsite_link} rel="noreferrer" target="_blank">
                        {is_legacy && (
                            <Button text="visit microsite" theme="green" />
                        )}
                    </a>
                )}
            </Section>
        );
    }

    return is_active ? renderActive() : renderPast();
};
